module.exports = __webpack_public_path__ + "static/media/ttm-loader.3fa9c4b1.gif";